import { AnimatePresence, motion } from "framer-motion";
import {
  GraduationCap,
  Users,
  DollarSign,
  HeartHandshake,
  Lightbulb,
  Apple,
  Sprout,
  Recycle,
  Cpu,
} from "lucide-react";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";

import { ProcessContentImage } from "../../components/ProcessContentImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import Accordion from "../../components/Accordion";
import FixedHeader from "../../components/FixedHeader";
import video from "../../videos/loop_pcyt.mp4";
const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/392b298a-6632-4920-acb6-dbcf585ae971" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen2.field_media_image," +
  "field_imagen3.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen19.field_media_image," +
  "field_imagen24.field_media_image," +
  "field_imagen25.field_media_image," +
  "field_imagen26.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30,field_bloque31,field_bloque32,field_bloque33,field_bloque34,field_bloque35,field_bloque36,field_bloque37,field_bloque38,field_bloque39," +
  "field_imagen3,field_imagen2,field_imagen5,field_imagen6,field_imagen19,field_imagen24,field_imagen25,field_imagen26" +
  "&fields[media--image]=field_media_image";

const base_URl = "https://portales.utpl.edu.ec/beportales/";
export default function Mia() {
  const DataDisplay = ({ data }) => (
    <>
      <FixedHeader
        video={video}
        src="https://utpl.edu.ec/recursos/img/cabecera.jpg"
        span0={
          <>
            UTPL <b>Parque</b>
          </>
        }
        span3="Científico y"
        span4="Tecnológico"
      ></FixedHeader>
      <div></div>
      {data.bloque1 && (
        <section className="max-w-6xl m-auto px-6 sm:px-0 py-8 mt-10">
          <div className="[&_img]:h-16 [&_img]:w-auto [&_img]:m-auto text-center max-w-3xl m-auto ">
            <ProcessContentImage
              content={data.bloque1}
              baseUrl={base_URl}
            ></ProcessContentImage>
          </div>
        </section>
      )}
      <section className="max-w-6xl m-auto px-6 sm:px-0">
        <h2>
          Nuestros <b>objetivos</b>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-4 pb-16">
          {data.bloque2 && (
            <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
              <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                <Lightbulb size={28} />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque2,
                }}
              />
            </div>
          )}

          {data.bloque3 && (
            <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
              <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                <GraduationCap size={28} />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque3,
                }}
              />
            </div>
          )}

          {data.bloque4 && (
            <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
              <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                <Users size={28} />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque4,
                }}
              />
            </div>
          )}
        </div>{" "}
      </section>

      <section className="bg-slate-50">
        <div className="max-w-6xl m-auto px-6 sm:px-0 ">
          {data.bloque5 && (
            <div className="max-w-3xl m-auto pt-16 text-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque5,
                }}
              />
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-4 pb-16 text-center">
            {data.bloque6 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center   border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <Apple size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </div>
            )}

            {data.bloque7 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <Sprout size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </div>
            )}

            {data.bloque8 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <Recycle size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque8,
                  }}
                />
              </div>
            )}

            {data.bloque9 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <Cpu size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque9,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="bg-gray-100">
        <div className="max-w-6xl m-auto px-6 sm:px-0 button-a [&_a]:m-auto py-16 ">
          {data.bloque5 && (
            <div className="max-w-3xl m-auto text-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque10,
                }}
              />
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center py-10 [&_h3_strong]:text-5xl mb-10">
            {[data.bloque11, data.bloque12, data.bloque13].map(
              (bloque, index) =>
                bloque && (
                  <div
                    key={index}
                    className="border-b-4 border-gray-300 pb-6 transition-colors duration-200 hover:border-[#004270]"
                    dangerouslySetInnerHTML={{ __html: bloque }}
                  />
                ),
            )}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-6xl m-auto px-6 sm:px-0 button-a [&_a]:m-auto py-16">
          {data.bloque14 && (
            <div className="max-w-3xl m-auto   text-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque14,
                }}
              />
            </div>
          )}

          <div>
            {data.bloque15 && (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque15,
                }}
              />
            )}

            {data.bloque16 && (
              <div className=" [&_img]:w-32 [&_img]:grayscale [&_img:hover]:grayscale-0 [&_img]:transition-all [&_img]:duration-300  [&_img]:inline-flex  [&_img]:p-4">
                <ProcessContentImage
                  baseUrl={base_URl}
                  content={data.bloque16}
                ></ProcessContentImage>
              </div>
            )}
          </div>

          <div>
            {data.bloque17 && (
              <div
                className="mt-10"
                dangerouslySetInnerHTML={{
                  __html: data.bloque17,
                }}
              />
            )}

            {data.bloque18 && (
              <div className="  [&_img]:w-32 [&_img]:grayscale [&_img:hover]:grayscale-0 [&_img]:transition-all [&_img]:duration-300  [&_img]:inline-flex  [&_img]:p-4">
                <ProcessContentImage
                  baseUrl={base_URl}
                  content={data.bloque18}
                ></ProcessContentImage>
              </div>
            )}
          </div>
        </div>
      </section>

      <BlockLeftImage
        src={data.imagen19}
        content={
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque19,
              }}
            />
          </>
        }
      ></BlockLeftImage>

      {/*retos */}
      <section
        className="bg-[#004270] 
      [&_h2]:text-white 
       [&_h3]:text-white 
        [&_h4]:text-white 
    [&_p]:text-white
      [&_li]:text-white py-24"
      >
        <div className="max-w-6xl m-auto  px-6 sm:px-0 ">
          {data.bloque20 && (
            <div
              className="text-center max-w-3xl m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque20,
              }}
            />
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 button-a  [&_h3_strong]:text-5xl mb-10">
            {[data.bloque21, data.bloque22].map(
              (bloque, index) =>
                bloque && (
                  <div
                    key={index}
                    className="border-b-4 border-white pb-6 transition-colors duration-200 hover:border-[#febe10]"
                    dangerouslySetInnerHTML={{ __html: bloque }}
                  />
                ),
            )}
          </div>
        </div>
      </section>

      {/*diferencia */}
      <section>
        <div className="max-w-6xl m-auto  py-16 px-6 sm:px-0 ">
          {data.bloque23 && (
            <div
              className="text-center max-w-3xl m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque23,
              }}
            />
          )}

          <div className="grid grid-cols-1 sm:grid-cols-3 mt-10 button-a gap-6 [&_a]:m-auto">
            {data.bloque24 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <img className="w-20 m-auto" src={data.imagen24}></img>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque24,
                  }}
                />
              </div>
            )}
            {data.bloque25 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <img className="w-20 m-auto" src={data.imagen25}></img>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque25,
                  }}
                />
              </div>
            )}
            {data.bloque26 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <img className="w-20 m-auto" src={data.imagen26}></img>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque26,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      {/*GESTION*/}
      <section className="bg-slate-50">
        <div className="max-w-6xl m-auto py-16  px-6 sm:px-0">
          {data.bloque27 && (
            <div
              className="text-center max-w-3xl m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque27,
              }}
            />
          )}

          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  mt-10 button-a gap-6 [&_a]:m-auto
        [&_h3_strong]:text-5xl"
          >
            {data.bloque28 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque28,
                  }}
                />
              </div>
            )}
            {data.bloque29 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque29,
                  }}
                />
              </div>
            )}
            {data.bloque30 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque30,
                  }}
                />
              </div>
            )}

            {data.bloque31 && (
              <div className="bg-white rounded-xl shadow-md p-6  border border-gray-100 text-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque31,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      {/*redes */}

      <section>
        <div className="max-w-6xl m-auto px-6 sm:px-0 button-a [&_a]:m-auto py-16">
          {data.bloque32 && (
            <div className="max-w-3xl m-auto   text-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque32,
                }}
              />
            </div>
          )}

          <div className="text-center">
            {data.bloque33 && (
              <div className=" [&_img]:w-32 [&_img]:grayscale [&_img:hover]:grayscale-0 [&_img]:transition-all [&_img]:duration-300  [&_img]:inline-flex  [&_img]:p-4">
                <ProcessContentImage
                  baseUrl={base_URl}
                  content={data.bloque33}
                ></ProcessContentImage>
              </div>
            )}
          </div>

          <div className="text-center">
            {data.bloque34 && (
              <div
                className="mt-10 text-center px-6 sm:px-0"
                dangerouslySetInnerHTML={{
                  __html: data.bloque34,
                }}
              />
            )}

            {data.bloque35 && (
              <div className="  [&_img]:w-32 [&_img]:grayscale [&_img:hover]:grayscale-0 [&_img]:transition-all [&_img]:duration-300  [&_img]:inline-flex  [&_img]:p-4">
                <ProcessContentImage
                  baseUrl={base_URl}
                  content={data.bloque35}
                ></ProcessContentImage>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="max-w-6xl m-auto px-6 sm:px-0 button-a [&_a]:m-auto py-16">
          <div
            dangerouslySetInnerHTML={{
              __html: data.bloque36,
            }}
          />
          <div
            className="
    text-center
    [&_.block-content-image]:grid
    [&_.block-content-image]:grid-cols-1
    [&_.block-content-image]:sm:grid-cols-2
    [&_.block-content-image]:lg:grid-cols-4
    [&_.block-content-image]:gap-6

    [&_.block-content-image>div]:rounded-2xl
    [&_.block-content-image>div]:bg-white
    [&_.block-content-image>div]:p-4
    [&_.block-content-image>div]:shadow-sm
    [&_.block-content-image>div]:transition-all
    [&_.block-content-image>div]:duration-300
    [&_.block-content-image>div:hover]:-translate-y-1
    [&_.block-content-image>div:hover]:shadow-lg

    [&_.block-content-image_img]:w-32
        [&_.block-content-image_img]:m-auto
         [&_.block-content-image_img]:mb-4
 
 
  "
          >
            <ProcessContentImage baseUrl={base_URl} content={data.bloque37} />
          </div>
        </div>
      </section>

      <section className="bg-[#0a3361]">
        <div className="max-w-6xl m-auto px-6 sm:px-0 py-16">
          <div
            className="text-center [&_h2]:text-white [&_p]:text-white"
            dangerouslySetInnerHTML={{
              __html: data.bloque38,
            }}
          />
<div
  className="
  text-center
    [&_img]:w-16
    [&_a]:inline-flex
    [&_a]:items-center
    [&_img]:mx-auto
    [&_img]:object-contain
    [&_img]:transition-transform
    [&_img]:duration-300
    [&_img:hover]:scale-110
  "
>
  <ProcessContentImage
    baseUrl={base_URl}
    content={data.bloque39}
  />
</div>
        </div>
      </section>
    </>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
